import { Link } from 'react-router-dom'
import { Breadcrumb ,message, Form,
  Input,
  InputNumber,
  Cascader,
  Row,
  Col,
  Checkbox,
  Button,
  AutoComplete } from 'antd';
import copy from "copy-to-clipboard";
import './RefundPolicy.less'
import {post} from '../../request/request'
import { useIntl } from 'react-intl';

const handleCopy = (value:any) => {
	copy(value);
	message.success('Copy successful!');
}


const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};


export default () => {
	const intl = useIntl();
	const [form] = Form.useForm();
	const onFinish = (values: any) => {
		post('snailcar/info/common/purchaseSnailcleInfo',{...values
	}).then((data) => {
		console.log(data)
		message.success('successful!');
		form.resetFields();
	})
	};
	return (
	<div className="RefundPolicy">
		<div className="page-routers-header">
			<Breadcrumb className="page-header-content">
				<Breadcrumb.Item>
				  <a href="/">{intl.formatMessage({id: 'header.menus.home'})}</a>
				</Breadcrumb.Item>
				<Breadcrumb.Item>{intl.formatMessage({id: 'footer.menus.support.Support'})}</Breadcrumb.Item>
			</Breadcrumb>
		</div>
		<div className="page-footer-container">
			<div className="page-footer-content">
				<div className="page-title">{intl.formatMessage({id: 'support.title'})}</div>
				<div>
					<div className="content-block">
						<p>{intl.formatMessage({id: 'support.con1'})}</p>
						<p className="title" style={{marginTop: '60px',textAlign: 'center'}}>{intl.formatMessage({id: 'support.con2'})}</p>
						<div className="inline-block-right content-block-right" style={{color: '#9A9A9A'}}>
							<p className="title">{intl.formatMessage({id: 'support.chat'})}</p>
							<p style={{margin: '20px 0 30px'}}>{intl.formatMessage({id: 'support.con3'})}</p>
							<Link to="/ContactUs"><Button type="primary" shape="round" block>{intl.formatMessage({id: 'support.message'})}</Button></Link>
							<p className="title" style={{margin: '100px 0 20px'}}>{intl.formatMessage({id: 'support.send.email'})}</p>
							<p>{intl.formatMessage({id: 'support.con5'})}</p>
						</div>
						<div className="inline-block-left content-block-left"  style={{color: '#9A9A9A'}}>
							<p className="title">{intl.formatMessage({id: 'support.send.email'})}</p>
							<p style={{margin: '20px 0 30px'}}>{intl.formatMessage({id: 'support.con4'})}</p>
							<Form
							  form={form}
							  layout="vertical"
							  name="register"
							  onFinish={onFinish}
							  initialValues={{
							    residence: ['zhejiang', 'hangzhou', 'xihu'],
							    prefix: '86',
							  }}
							  scrollToFirstError
							  style={{width: '100%',maxWidth: '450px'}}
							>
							  <Form.Item
							    name="name"
							    label={intl.formatMessage({id: 'form.label.Name'})}
							  >
							    <Input />
							  </Form.Item>

							  <Form.Item
							    name="email"
							    label={intl.formatMessage({id: 'form.label.Name'})}
							    rules={[
							      {
							        type: 'email',
							        message: intl.formatMessage({id: 'form.message.valid.email'}),
							      },
							      {
							        required: true,
							        message: intl.formatMessage({id: 'form.message.enter.email'}),
							      },
							    ]}
							  >
							    <Input />
							  </Form.Item>

							  <Form.Item
							    name="country"
							    label={intl.formatMessage({id: 'form.label.Country'})}
							  >
							    <Input style={{ width: '100%' }} />
							  </Form.Item>

							  <Form.Item
							    name="productModel"
							    label={intl.formatMessage({id: 'form.label.Model'})}
							    rules={[{ required: true, message: intl.formatMessage({id: 'form.message.Model'}) }]}
							  >
							    <Input style={{ width: '100%' }} />
							  </Form.Item>

							  <Form.Item
							    name="purchaseFrom"
							    label={intl.formatMessage({id: 'form.label.from'})}
							    rules={[{ required: true, message: intl.formatMessage({id: 'form.message.from'}) }]}
							  >
							    <Input style={{ width: '100%' }} />
							  </Form.Item>

							  <Form.Item
							    name="purchaseProof"
							    label={intl.formatMessage({id: 'form.label.Purchase'})}
							    rules={[{ required: true, message: intl.formatMessage({id: 'form.message.purchase.input'}) }]}
							  >
							    <Input style={{ width: '100%' }} />
							  </Form.Item>

							  <Form.Item
							    name="des"
							    label={intl.formatMessage({id: 'form.label.Description'})}
							    rules={[{ required: true, message: intl.formatMessage({id: 'form.message.des.input'}) }]}
							  >
							    <Input.TextArea placeholder={intl.formatMessage({id: 'form.message.des'})} style={{minHeight: '120px'}} />
							  </Form.Item>
							  <Form.Item >
							    <Button type="primary"  htmlType="submit" shape="round" block>{intl.formatMessage({id: 'form.btn.sub'})}</Button>
							  </Form.Item>
							</Form>
						</div>
						<div style={{clear: 'both'}}></div>
					</div>
				</div>
			</div>
		</div>
	</div>
)}